import { ReactNode } from "react";
import { LinkTerminosPrivacidad } from "@components/ui_v2";

/** Lo que cambia por empresa en "Crea tu cuenta" (`CrearCuenta`); la pantalla y su lógica son las mismas. */
export interface CrearCuentaConfig {
  /**
   * Leyenda de la casilla que se acepta para continuar, con sus enlaces. `null`: la pantalla no lleva casilla
   * (`S_Usuario consent="ninguno"` del prototipo) porque la empresa la acepta antes, en su cotizador.
   */
  terminosLabel: ReactNode | null;
  /**
   * Casilla opcional "Quiero recibir noticias y promociones", sin marcar de inicio, y leyenda de que al continuar se
   * aceptan los términos (`consent="promos"` del prototipo, WuWei). Va en lugar de `terminosLabel`.
   */
  promociones: boolean;
}

const DEFAULT_CONFIG: CrearCuentaConfig = {
  terminosLabel: (
    <>
      Acepto los <LinkTerminosPrivacidad termsLabel="términos y condiciones" connector="y el" />
    </>
  ),
  promociones: false,
};

/** Por empresa (`getConfigName`); si la empresa no está aquí se usa el default. */
const crearCuentaPorEmpresa: Record<string, CrearCuentaConfig> = {
  // Mercader acepta el aviso de privacidad en su cotizador (`CotizadorMercader`), no aquí.
  mercader: {
    ...DEFAULT_CONFIG,
    terminosLabel: null,
  },
  // Flux acepta los términos y la política de privacidad en su cotizador (`CotizadorFlux`).
  flux: {
    ...DEFAULT_CONFIG,
    terminosLabel: null,
  },
  wuwei: {
    terminosLabel: null,
    promociones: true,
  },
};

export const getCrearCuentaConfig = (configName: string): CrearCuentaConfig =>
  crearCuentaPorEmpresa[configName] ?? DEFAULT_CONFIG;
